import { loginApi, postPhoneLoginApi } from '@/api/login'
import useAfterLogin from './useAfterLogin'
import useAfterInformation from './useAfterOnboarding'
import { useState } from 'react'
import { SUCCESS_CODE } from '@/utils/constants'
import { FormInstance } from '@arco-design/web-react'
import { getPromotionInfo } from './useBdVid'
import { isEmpty } from '@/utils/is'

// 表单提交数据登录
const useFormLogin = ({ form }: { form: FormInstance<any, any, string | number | symbol> }) => {
  const { afterLoginSuccess, afterPhoneLoginSuccess } = useAfterLogin({})
  const { afterRegisterSuccess, afterPhoneRegisterSuccess } = useAfterInformation({ rememberPassword: false })
  const [loading, setLoading] = useState(false)
  const promotionInfo = getPromotionInfo()

  // 密码
  const onSubmitClick = () => {
    form
      ?.validate()
      .then((values) => {
        setLoading(true)
        loginApi(values)
          .then((res) => {
            const { code } = res?.data || {}
            if (code === SUCCESS_CODE) {
              if (isEmpty(res?.data?.data?.user?.role)) {
                //没填信息， 注册成功
                afterRegisterSuccess(values, res.data)
              } else {
                //填过信息， 登录成功
                afterLoginSuccess(values, res.data)
              }
            } else {
              console.log(code)
            }
          })
          .catch((err) => {
            // 设置错误信息
            const errors = err?.response?.data?.errors || {}
            form?.setFields({
              // 存在则展示，不存在不展示
              email: errors.email
                ? {
                    value: values.email,
                    error: {
                      message: errors.email
                    }
                  }
                : undefined,
              password: errors.password
                ? {
                    value: values.password,
                    error: {
                      message: errors.password
                    }
                  }
                : undefined
            })
          })
          .finally(() => {
            setLoading(false)
          })
      })
      .catch((err) => {
        console.log('提交err', err)
      })
  }

  const onPhoneSubmitClick = () => {
    form
      ?.validate()
      .then((values) => {
        setLoading(true)
        const params = {
          ...values,
          ...promotionInfo
        }
        postPhoneLoginApi(params)
          .then((res) => {
            const { code } = res?.data || {}
            if (code === SUCCESS_CODE) {
              if (!res.data.data.user.role) {
                afterPhoneRegisterSuccess(values, res.data)
              } else {
                afterPhoneLoginSuccess(values, res.data)
              }
            } else {
              console.log(code)
            }
          })
          .catch((err) => {
            // 设置错误信息
            const errors = err?.response?.data?.errors || {}
            form?.setFields({
              // 存在则展示，不存在不展示
              phone: errors.phone
                ? {
                    value: values.phone,
                    error: {
                      message: errors.phone
                    }
                  }
                : undefined,
              code: errors.code
                ? {
                    value: values.code,
                    error: {
                      message: errors.code
                    }
                  }
                : undefined
            })
          })
          .finally(() => {
            setLoading(false)
          })
      })
      .catch((err) => {
        console.log('提交err', err)
      })
  }

  return {
    onSubmitClick,
    loading,
    onPhoneSubmitClick
  }
}

export default useFormLogin
